<template>
  <div class="time">
    <div class="time__wrapper">
      <Datepicker
        v-model="time"
        locale="pt-BR"
        time-picker
        enable-time-picker
      />

      <input
        type="hidden"
        :name="name"
        :value="formattedTime"
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import Datepicker from '@vuepic/vue-datepicker'

import '@vuepic/vue-datepicker/dist/main.css'

export default defineComponent({
  name: 'GlobalTimePicker',

  components: {
    Datepicker
  },

  props: {
    name: {
      type: String,
      default: () => ''
    },

    modelValue: {
      type: Object,
      default: () => {
        const date = new Date()

        const [hours, minutes] = [date.getHours(), date.getMinutes()]

        return {
          hours,
          minutes
        }
      }
    }
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    time: {
      get () {
        return this.modelValue ?? this.initialHours
      },

      set (v) {
        const hour = v ?? this.initialHours

        this.$emit('update:modelValue', hour)
      }
    },

    initialHours () {
      return {
        hours: 0,
        minutes: 0
      }
    },

    formattedTime () {
      const { hours, minutes } = this.time

      const [hh, mm] = [hours, minutes].map(time => String(time).padStart(2, '0'))

      return `${hh}:${mm}`
    }
  }
})
</script>

<style lang="scss" scoped>
  .time {
    &__wrapper {
      width: 103px;
      height: 40px;

      div,
      input,
      :deep(div),
      :deep(input){
        height: 100% !important;
      }

      :deep(.dp__input_icon) {
        display: none;
      }

      :deep(.dp__pointer) {
        border-radius: 24px;
        padding-inline: 12px;
        border: solid 1px rgb(var(--gray9));

        letter-spacing: 0.05rem;
        color: var(--primary-dark2);
        font: 400 1.4rem / 2rem "Nunito", sans-serif;
      }
    }
  }
</style>
